export { TabEdit } from './tab-edit';
